import React from 'react';
import ReactDOM from 'react-dom/client';
import RootElement from './routes';
import '../src/assets/scss/styles.scss';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<RootElement />);